// extracted by mini-css-extract-plugin
export default {"rank":"StatsRowRank_rank__TNFdp"};